import React from "react";
import ImageBG from "../../images/our-capabilities-bg.png";
import LazyLoad from 'react-lazyload';

function GridLayoutImage(props) {
  
  return (
      <div className="digital-transformation-build-image">
        <LazyLoad>
          <img src={ImageBG} alt="Transform your business" title="Transform your business" />
        </LazyLoad>
      </div>
  );
};

export default GridLayoutImage; 